module.exports = __webpack_public_path__ + "img/product9.cd9ec587.png";